<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  async mounted() {
    await this.$store.dispatch('FETCH_SETTINGS')
    await this.$store.dispatch('FETCH_CATEGORIES')
    await this.$store.dispatch('FETCH_BRANDS')
  }
}
</script>